<template>
   <div class="nav-layout shifted-content h-vh-100">
      <Dialogs />
      <Sidebar />

      <Appbar :user=true />
      <div data-role="charms" id="agentbuilding" ref="agentbuilding" data-position="right" data-cls-charms="h-100 overflow bd-gray bg-white" 
         v-show="iframeLoaded" v-cloak>
         <div class="row p-3 mb-4">
            <h3 class="cell-11 text-left fg-black">{{ $t("Generate and Download Agent Setup") }}</h3>
            <div class="cell-1">
               <!--button onclick="$('#notifications').data('charms').toggle()" class="button bg-white"><span class="icon mif mif-close mif-2x mif-bin"> </span></button-->
               <button @click="toggleAgent" class="button bg-white">
                    <span class="icon mif mif-cross">
                    </span>
                </button>
            </div>
         </div>
         <div class="row">
            <div class="col">
               <div>
                  <iframe allowfullscreen sandbox="allow-popups allow-top-navigation allow-same-origin allow-scripts allow-modals allow-forms allow-downloads"
                     :src="parentIframeSrc" width="500" height="600" loading="eager" @load="onIframeLoad"></iframe>
               </div>
            </div>
         </div>
      </div>
      <div class="docs-content bg-light h-vh-100">
         <transition name="slide-fade" v-cloak>
            <router-view :key="$route.path" />
         </transition>
      </div>
      <FileSystemSidebar />
      <!--addLicenseDialog :license="license" :pricing="pricing"></addLicenseDialog> -->
      <BackupManager ref="backupManager"/>
   </div>
</template>
<script>
   import Appbar from '../layouts/Appbar';
   import Sidebar from '../layouts/Sidebar.vue';
   import FileSystemSidebar from '../components/FileSystemSidebar';
   import Dialogs from '../components/Dialogs';
   import BackupManager from '../components/silentcomponents/BackupManager.vue';
   export default {
       name: 'nav-layout',
   
       components: {
           Appbar,
           Sidebar,
           FileSystemSidebar,
           Dialogs,
           BackupManager
       },
       created: function () {
           //console.log("CREATED Nav Layout!!!")
           this.getAgentIframeUrl();
           //this.noIperiusOneLicense = this.$session.getLicenses()?.backup?.length == 0
       },
       watch: {

           // intercetta il cambiamento della lingua e crea nuovo url della generazione agent su iperiuds, introdotto perchè il bottone "scarica agent" è stato spostato in AppBar
           '$i18n.locale': function (newLocale, oldLocale) {
               this.getAgentIframeUrl();
           }
   
       },
       data() {
           return {
               iframeLoaded: false,
               subMenuOpen: '',
               loader: false,
               licenses: {},
               license: {
                   num_users: 1,
                   num_workstations: 0,
                   num_servers: 0,
                   num_vms: 0,
                   plugin_exchange: 0,
                   plugin_database: 0,
                   plugin_tape: 0,
                   subscription_duration: 1,
                   discount_code: null,
                   currency: 'EUR'
               },
               parentIframeSrc: '',
               trustedSrc: "",
               urlagentbuild: process.env.VUE_APP_AGENT_BUILD_BASE_URL,
               //noIperiusOneLicense: true,
               //noIperiusOneLicensePolicies:true,
           }
       },
       methods: {
   
           onIframeLoad() {
               this.iframeLoaded = true; // Cambia lo stato quando il contenuto è caricato
           },
   
           toggleAgent() {
               window.Metro.charms.close('#agentbuilding')
           },
   
           // [TG - 18/06/2024 - generazione link apertura iframe build agent]
           async getAgentIframeUrl() {
               let self = this;
   
               //const div = document.getElementById('notifications');
               //const isOpened = div.hasAttribute('data-opened');
               //console.log('Notifications div is ' + (isOpened ? 'open' : 'closed'));
              if (!self.$root.checkAuth() || self.$root.authObj.licenceExpired == true) {
                   return;
               }
   
               let ima = self.$root.authObj.id_master_account;
               let doa = self.$root.authObj.dataora_attivazione.toLocalDate();
               let dos = self.$root.authObj.dataora_scadenza.toLocalDate();
               let sc = '|';
   
               let cryLic = await self.$api.getCoCod(ima);
   
               if (cryLic != null) {
   
                   //let ext_lic_info=await self.$api.getLicenseExtendedInfo();
                   //const ext_lic_info = this.$session.getLicenses();
   
                   //let ext_lic_info=await self.$api.getLicenseExtendedInfo();
                   let ext_lic_info = this.$session.getLicenses();
   
                   if (ext_lic_info == null) {
                       ext_lic_info = await self.$api.getLicenseExtendedInfo();
                       if (ext_lic_info != null) {
                           this.$session.setLicenses(ext_lic_info);
                       }
                   }
   
   
                   if (ext_lic_info != null) {
   
                       // normalizza il JSON delle caratteristiche aggiuntive della licenza in una unica stringa
                       // come da esempio: "nome_licenza: WorkstationBackup, max_control_connections: 0, max_host_list: 0, units: 10 + nome_licenza: ServerBackup, max_control_connections: 0, max_host_list: 0, units: 10 + nome_licenza: ExchangeModule, max_control_connections: 0, max_host_list: 0, units: 1 + nome_licenza: Backup, max_control_connections: 0, max_host_list: 0, units: 5 + nome_licenza: Small, max_control_connections: 2, max_host_list: 50, units: 1"
                       let nl = Object.keys(ext_lic_info)
                           .filter(category => category !== 'remote' && category !== 'general') // Escludi "remote" e "general"
                           .map(category => {
                               return ext_lic_info[category].map(license => {
                                   // Verifica se la licenza ha i campi `max_control_connections` e `max_host_list`
                                   if ('max_control_connections' in license && 'max_host_list' in license) {
                                       return `nome_licenza: ${license.description}, max_control_connections: ${license.max_control_connections}, max_host_list: ${license.max_host_list}, units: ${license.units || 'N/A'}`;
                                   }
                                   // Altrimenti serializza solo i campi comuni
                                   return `nome_licenza: ${license.description}, units: ${license.units || 'N/A'}`;
                               }).join(' + ');
                           }).join(' + ');
   
                       let currentDate = new Date();
                       let formattedDate = this.$moment(currentDate).format('YYYYMMDD');
   
                       let lang_code = localStorage.getItem('lang') ?? $i18n.locale ?? "en";
   
                       let qry_string = ima + sc + doa + sc + dos + sc + formattedDate + sc + nl + sc + lang_code + sc + cryLic.result;
   
                       let param = await self.$api.getCrio(qry_string);
   
                       var trustedSrc = self.urlagentbuild + '?lang=' + lang_code + '&pl=' + encodeURIComponent(param.result);
                       //console.log(trustedSrc);
                       self.parentIframeSrc = trustedSrc;
                       // il componente padre (Dashboard.vue) ascolterà gli eventi emessi dal componente figlio (Navigation.vue)
                       // va dunque a cambiare la proprietà src dell'iframe (iframe si apre su Dashboard.vue, mentre il link viene creato in Navigation.vue)
                       //this.$emit('update-iframesrc', self.trustedSrc);
   
                   }
   
                   //self.noIperiusOneLicense = this.$session.getLicenses()?.backup?.length === 0;
   
               }
   
           },
   
           // [TG - 18/06/2024 - gestione finiestra generazione agent]
           updateParentIframeSrc(newIframeSrc) {
               this.parentIframeSrc = newIframeSrc;
           },
   
   
           // --------------------------------------------------------------------------
   
       },
   
   }
</script>

<style>
   #agentbuilding {
      top: 52px;
      height: calc(100vh - 52px) !important;
   }
</style>
